import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, EyeOff, PhoneCall, Clock, HelpCircle, FileQuestion } from 'lucide-react';
const problems = [{
  icon: EyeOff,
  text: 'Tu aviso se pierde entre miles de publicaciones'
}, {
  icon: PhoneCall,
  text: 'El 80% de los que te contactan son corredores, no compradores'
}, {
  icon: Clock,
  text: 'Pierdes fines de semana en visitas que no llevan a nada'
}, {
  icon: HelpCircle,
  text: 'No sabes si tu precio está bien — y eso te cuesta plata'
}, {
  icon: FileQuestion,
  text: 'Negocias a ciegas, sin datos ni respaldo'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 10
  },
  visible: {
    opacity: 1,
    y: 0
  }
};
export function ProblemSection() {
  return <section className="py-20 px-6 bg-gray-50" data-id="element-174">
      <div className="max-w-3xl mx-auto" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-176">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-red-100 text-red-600 mb-6" data-id="element-177">
            <AlertCircle size={24} data-id="element-178" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-gray-900" data-id="element-179">
            Publicas tu propiedad… <br className="hidden md:block" data-id="element-180" />
            <span className="text-gray-500" data-id="element-181">y te llaman puros corredores.</span>
          </h2>
          <p className="text-lg text-gray-500 mt-4" data-id="element-182">
            Vender sin corredor parece buena idea, hasta que empieza el caos.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true
      }} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 md:p-8" data-id="element-183">
          <ul className="space-y-4" data-id="element-184">
            {problems.map((problem, index) => {
            const Icon = problem.icon;
            return <motion.li key={index} variants={itemVariants} className="flex items-center gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors" data-id="element-185">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-red-50 flex items-center justify-center text-red-500" data-id="element-186">
                    <Icon size={20} data-id="element-187" />
                  </div>
                  <span className="text-lg text-gray-700 font-medium" data-id="element-188">
                    {problem.text}
                  </span>
                </motion.li>;
          })}
          </ul>
        </motion.div>
      </div>
    </section>;
}